import React, { } from "react";
import { Pressable, Text, Image } from "react-native";

import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

import * as CommonUtils from '../services/CommonUtils';

export const UserProfleFeatureWidget = (props) => {
    return (<Pressable style={[AppStyles.flexRowStart]}
        onPress={props?.onPress} onLongPress={() => { console.log('### long press') }}>
        <Image source={{
            uri: CommonUtils.getImagePath('/images/userProfile/' + props.iconName + '.svg'),
            width: 24, height: 24
        }} />
        <Text style={[TextStyle.text14b, { marginLeft: 16 }]}>
            {props?.title} </Text>
    </Pressable>
    )
}